import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';

export const SOURCE_DISPLAY = { ice: 'ICE', sky: 'Sky', spider: 'Spider' };
export const SOURCES = ['ice', 'sky', 'spider'];

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'Date',
        type: filterHeaderTypes.filterTypes.dateFromOnly,
        defaultValue: { from: lastWorkingDay(), to: lastWorkingDay(), today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        useValidation: true,
        hideAllButton: true,
        hideToday: true
    }
];

export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: lastWorkingDay(),
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    }
];

export const defaultGridSorting = [
    { gridId: 'fileAvailability', gridSort: [{ id: 'fileName', desc: false }] }
];

export const columns = [
    { id: 'fileName', visible: true, sortable: true },
    { id: 'status', visible: true, sortable: true },
    { id: 'download', visible: true, sortable: false, width: 110 }
];
